interface FileMetaProps {
  url: string;
  filename: string;
}

export const handleDownload = async (files: FileMetaProps[]) => {
  files.map((file) => {
    fetch(file.url, { method: 'GET' })
      // 응답 데이터를 Blob 객체로 변환
      .then((response) => response.blob())
      .then((blob) => {
        // Blob 객체 생성하고 URL을 생성
        const _url = window.URL.createObjectURL(blob);
        const _link = document.createElement('a');

        // 생성한 URL과 다운로드할 파일명 설정
        _link.setAttribute('href', _url);
        _link.setAttribute('download', file.filename);

        // 링크를 문서에 추가
        document.body.appendChild(_link);

        // 링크 클릭 => 파일 다운로드
        _link.click();

        // 다운로드 후 링크와 URL을 정리
        _link.parentNode?.removeChild(_link);
        window.URL.revokeObjectURL(_url);
      });
  });
  // URL에서 GET 요청 보내기
};
